module.exports = __webpack_public_path__ + "img/monterey-g-series-high-angle.5c0e70fa.png";